import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import CustomerDatabase from "../../../../../pages/CustomerDatabase";
import { RemoteFetchUserDetails } from "../../../../../../data/usecases/remote-fetch-user-details";


interface ExceededAreaModalProps {
  open: boolean;
  onClose: () => void;
}



const ExceededAreaModal: React.FC<ExceededAreaModalProps> = ({
  open,
  onClose,
}) => {


  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Area Limit Exceeded</DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="textSecondary">
          Your selected areas exceed the 25 km limit. Please
          stay within the 25 km range.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExceededAreaModal;
